var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-content__section"},[_vm._v("\n    Comliance Block\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }